var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M937 448L937 476",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 937.5,
    cy: 443.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M948.829 440.888L938.354 437.027C938.278 436.991 938.202 436.991 938.126 437.027L927.651 440.888C927.651 440.888 927.651 440.888 927.632 440.888C927.613 440.888 927.613 440.906 927.594 440.906C927.594 440.906 927.575 440.906 927.575 440.923C927.556 440.923 927.556 440.941 927.537 440.941C927.537 440.941 927.537 440.941 927.518 440.959C927.499 440.976 927.499 440.976 927.48 440.994C927.48 441.012 927.461 441.012 927.461 441.03V441.047C927.461 441.065 927.461 441.065 927.442 441.083V441.1C927.442 441.118 927.442 441.136 927.442 441.154V445.741C926.626 445.883 926 446.556 926 447.353C926 448.256 926.797 449 927.765 449C928.733 449 929.53 448.256 929.53 447.353C929.53 446.538 928.903 445.883 928.087 445.741V441.579L930.118 442.323V445.387C930.118 446.272 930.991 447.087 932.604 447.689C934.122 448.238 936.115 448.557 938.24 448.557C940.366 448.557 942.377 448.256 943.876 447.689C945.47 447.105 946.362 446.29 946.362 445.387V442.323L948.81 441.419C948.924 441.384 949 441.277 949 441.154C949 441.03 948.943 440.941 948.829 440.888ZM928.922 447.353C928.922 447.937 928.41 448.415 927.784 448.415C927.158 448.415 926.645 447.937 926.645 447.353C926.645 446.768 927.158 446.29 927.784 446.29C928.41 446.29 928.922 446.768 928.922 447.353ZM945.755 445.404C945.755 446.662 942.738 447.99 938.24 447.99C933.743 447.99 930.725 446.644 930.725 445.404V442.553L938.126 445.28C938.164 445.298 938.202 445.298 938.24 445.298C938.278 445.298 938.316 445.298 938.354 445.28L945.755 442.553V445.404ZM945.945 441.88L938.24 444.714L930.535 441.862L928.6 441.154L938.24 437.593L947.88 441.154L945.945 441.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool3);
export default __webpack_public_path__ + "static/media/school_3.70b07549c2683ee746daacace25150ef.svg";
export { ForwardRef as ReactComponent };